import { connect } from 'react-redux'
import { getUserDto, isAuthenticated, isResetPasswordInProgress } from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'
import { IDispatchProps, IStateProps, Login } from './Login'
import { doLogin, setLoginInProgress, checkLoginMethod, resetLoginStep } from './store/LoginActions'
import { reLocate } from '../../common/Routes/RouterActions'
import {
  getLoginInProgress,
  getLoginStep,
  getLoginMethod,
  getSsoCompanyId,
  getSsoCompanyName,
  getSsoConfigId,
  getIsCheckingLoginMethod,
} from './store/LoginSelectors'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  authenticated: isAuthenticated(state),
  userDto: getUserDto(state),
  isLoginInProgress: getLoginInProgress(state),
  // SSO email-first flow state
  loginStep: getLoginStep(state),
  loginMethod: getLoginMethod(state),
  ssoCompanyId: getSsoCompanyId(state),
  ssoCompanyName: getSsoCompanyName(state),
  ssoConfigId: getSsoConfigId(state),
  isCheckingLoginMethod: getIsCheckingLoginMethod(state),
})

const mapDispatchToProps: IDispatchProps = {
  doLogin,
  reLocate,
  setLoginInProgress,
  // SSO email-first flow actions
  checkLoginMethod,
  resetLoginStep,
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
